import { fire as firebase } from "../config/firebase.config";
import { FUNCTIONS_URL, MESSAGE_TYPES as msg } from "../utils/js/constants";
import axios from "axios";
import { checkAuthentication, handleLogout } from "./firebaseFunctions";

const URL = `${FUNCTIONS_URL}/admin`;

const createUserRecord = async (user, callback = () => {}) => {
    const headers = { authorization: await getLoggedUserToken() };

    axios.post(URL, user, { headers })
      .then(({ data }) => callback({message: msg.USER_CREATED, result: data, error: null}))
      .catch(error => callback({message: msg.USER_CREATED_ERROR, result: null, error: error}))
}

const getAllUsers = async (callback = () => {}) => {
    const headers = { authorization: await getLoggedUserToken() };

    axios.get(URL, { headers })
      .then(({ data }) => callback(data.users || []))
      .catch(async err => {
          if (err.response.status === 403) await handleLogout();
      })
};

const resetUserPasswordByEmail = (emailAddress, callback = () => {}) => {
    let data = {};

    firebase.auth().sendPasswordResetEmail(emailAddress).then(() => {
        data = {message: msg.USER_PASSWORD_RESET, result: null, error: null};
    })
    .catch((error) => {
        data = {message: msg.USER_PASSWORD_RESET_ERROR, result: null, error: error};
    })
    .finally(() => callback(data));
}

const removeUsersById = async (uid, callback =() => {}) => {
    const headers = { authorization: await getLoggedUserToken() };
    const params = { uid };

    axios.delete(URL, { params, headers })
      .then(callback)
      .catch(console.log)
}

const getLoggedUserToken = async () => {
    const loggedUser = await checkAuthentication();
    let stsTokenManager = loggedUser.stsTokenManager;
    return stsTokenManager.accessToken;
}

export { createUserRecord, getAllUsers, resetUserPasswordByEmail, removeUsersById };
